import { cacheTypes, getheader, getMethodByCallBack, postMethodByCallBack, serverUrl } from "../../../store/api/CommonFunctions";
export function getAllProvinces() {
    return dispatch => {
        dispatch({
            type: "FETCH_DATA_PROVINCE",
            data: "PENDING"
        })
        fetch(serverUrl + "ProvinceAPI/SelectAllProvince")
            .then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                dispatch(
                    {
                        type: "FETCH_DATA_PROVINCE",
                        data: res
                    })
            }).catch(err => {
                console.error('[FETCH_DATA_PROVINCE_LIST]', err);
                dispatch(
                    {
                        type: "FETCH_DATA_PROVINCE",
                        data: null
                    })
            })

    }
}
export function getCityList(provinceID) {
    return dispatch => {
        if (!provinceID) {
            return dispatch({
                type: "FETCH_DATA_CITY_LIST",
                data: []
            })
        }
        dispatch(
            {
                type: "FETCH_DATA_CITY_LIST",
                data: "PENDING"
            }
        )
        fetch(serverUrl + "CityAPI/SelectByIdCity?ProvinceId=" + provinceID, {
            headers: getheader()
        })
            .then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                dispatch({
                    type: "FETCH_DATA_CITY_LIST",
                    data: res
                })
            }).catch(err => {
                console.log("[FETCH_DATA_CITY_LIST]", err);
                dispatch({
                    type: "FETCH_DATA_CITY_LIST",
                    data: null
                })
            })
    }
}
export function getZoneList(cityID) {
    return dispatch => {
        if (!cityID) {
            return dispatch({
                type: "FETCH_DATA_ZONE_LIST",
                data: []
            })
        }
        dispatch(
            {
                type: "FETCH_DATA_ZONE_LIST",
                data: "PENDING"
            }
        )
        fetch(serverUrl + "api/ZoneAPI/SelectZoneByCity?cityID=" + cityID)
            .then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                dispatch(
                    {
                        type: "FETCH_DATA_ZONE_LIST",
                        data: res
                    }
                )
            }).catch(err => {
                console.log("[FETCH_DATA_ZONE_LIST]", err);
                dispatch(
                    {
                        type: "FETCH_DATA_ZONE_LIST",
                        data: null
                    }
                )
            })
    }
}
export function setLocation(data) {
    return dispatch => {
        dispatch({
            type: "SET_CURRENT_LOCATION",
            data: data
        })
    }
}
/**
 * 
 * @param {json} cityData 
 * @param {function} onAddUpdate 
 */
export function addOrUpdateCity(cityData, onAddUpdate) {
    return dispatch => {
        const onGetReponse = (res) => {
            if (res.Data) {
                dispatch({
                    type: "FETCH_DATA_CITY_LIST",
                    data: res.Data
                })
            }
            if (onAddUpdate) {
                onAddUpdate(res);
            }
        }
        postMethodByCallBack("CityAPI/AddOrUpdateCity", cityData, onGetReponse, "AddOrUpdateCity");
    }
}
export function deleteCity(cityID, onDelete) {
    return dispatch => {
        const onGetReponse = (res) => {
            if (res.Data) {
                dispatch({
                    type: "FETCH_DATA_CITY_LIST",
                    data: res.Data
                })
            }
            if (onDelete) {
                onDelete(res);
            }
        }
        getMethodByCallBack(`CityAPI/DeleteCity?Id=${cityID}`, cacheTypes.NoCache, onGetReponse, "DeleteCity");
    }
}
export function addOrUpdateZone(zoneData, onAddUpdate) {
    return dispatch => {
        const onGetReponse = (res) => {
            if (res.Data) {
                dispatch({
                    type: "FETCH_DATA_ZONE_LIST",
                    data: res.Data
                });
            }
            if (onAddUpdate) {
                onAddUpdate(res);
            }
        }
        postMethodByCallBack("api/ZoneAPI/AddOrUpdateZone", zoneData, onGetReponse, "AddOrUpdateZone");
    }
}
export function deleteZone(id, onDelete) {
    return dispatch => {
        const onGetReponse = (res) => {
            if (res.Data) {
                dispatch({
                    type: "FETCH_DATA_ZONE_LIST",
                    data: res.Data
                });
            }
            if (onDelete) {
                onDelete(res);
            }
        }
        getMethodByCallBack(`api/ZoneAPI/DeleteZone?Id=${id}`, cacheTypes.NoCache, onGetReponse, "DeleteZone");
    }
}